import { Link } from "@tanstack/react-router";
import { motion } from "motion/react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/hooks/use-auth";

export function LNavbar() {
  const { currentUser } = useAuth();

  return (
    <motion.header
      initial={{ y: -20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="fixed top-0 left-0 right-0 z-50 bg-[#0a0a0a]/80 backdrop-blur-xl border-b border-[#9B87F5]/10"
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3 group">
            <div className="relative">
              <pre className="font-mono text-[#9B87F5] text-[8px] leading-[1] group-hover:text-white transition-colors duration-300">
                {`██╗     
██║     
██║     
██║     
███████╗
╚══════╝`}
              </pre>
              <motion.div
                className="absolute inset-0 bg-[#9B87F5]/20 blur-xl"
                animate={{ opacity: [0.3, 0.6, 0.3] }}
                transition={{ duration: 2, repeat: Infinity }}
              />
            </div>
            <div className="hidden sm:block">
              <span className="text-white font-mono text-lg tracking-wider">
                LINK SHORTENER
              </span>
              <p className="text-[#8E9196] text-xs font-mono">
                // the name you can trust
              </p>
            </div>
          </Link>

          {/* Navigation */}
          <nav className="flex items-center gap-4">
            {currentUser ? (
              <Link to="/dashboard">
                <Button
                  variant="outline"
                  className="border-[#9B87F5]/30 text-[#9B87F5] hover:bg-[#9B87F5]/10 hover:text-white font-mono"
                >
                  [ DASHBOARD ]
                </Button>
              </Link>
            ) : (
              <>
                <Link to="/sign-in" className="hidden sm:block">
                  <Button
                    variant="ghost"
                    className="text-[#8E9196] hover:text-white font-mono"
                  >
                    SIGN_IN
                  </Button>
                </Link>
                <Link to="/sign-up">
                  <Button className="bg-[#9B87F5] hover:bg-[#8B5CF6] text-black font-mono font-bold">
                    [ GET STARTED ]
                  </Button>
                </Link>
              </>
            )}
          </nav>
        </div>
      </div>
    </motion.header>
  );
}
